import { render, staticRenderFns } from "./infoOpinionBoardDetail.vue?vue&type=template&id=21312824"
import script from "./infoOpinionBoardDetail.vue?vue&type=script&lang=js"
export * from "./infoOpinionBoardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21312824')) {
      api.createRecord('21312824', component.options)
    } else {
      api.reload('21312824', component.options)
    }
    module.hot.accept("./infoOpinionBoardDetail.vue?vue&type=template&id=21312824", function () {
      api.rerender('21312824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/iob/infoOpinionBoardDetail.vue"
export default component.exports